import { css } from '@emotion/react';

export const selectGlobalStyles = css`
  .custom-ant-select-dropdown {
    padding: 0;
  }
`;
